import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, combineLatest, iif, of } from 'rxjs';
import { shareReplay, switchMap, take } from 'rxjs/operators';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { BaseSiteConfigService, CHANGE_DELIVERY_ADDRESS } from 'src/app/service/base-site/base-site-config.service';
import { ShimanoBusinessTypeService } from 'src/app/service/businessType/shimano-business-type.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import {
  COUNTY,
  DELETE_DELIVERY_ADDRESS,
  EDIT_BILLING_ADDRESS,
  EDIT_DEFAULT_DELIVERY_ADDRESS,
  MyaccountFeaturesConfigService,
  REQUEST_NEW_DELIVERY_ADDRESS,
} from 'src/app/service/myaccount/myaccount-features-config.service';
import {
  DefaultAddressPayload,
  MyaccountPersonalInfoService,
} from 'src/app/service/myaccount/myaccount-personal-info.service';
import { ACCOUNT_PERMISSIONS, SnahCountryService } from 'src/app/service/snah/snah-countries.service';
import { StorageService } from 'src/app/service/storage/storage.service';
// tslint:disable-next-line: max-line-length
// tslint:disable-next-line: max-line-length

@Component({
  selector: 'app-myaccount-personalinfo-address',
  templateUrl: './myaccount-personalinfo-address.component.html',
  styleUrls: ['./myaccount-personalinfo-address.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MyaccountPersonalinfoAddressComponent implements OnInit, OnDestroy {
  address$: Observable<any> = this.personalInfoSvc.getAddress();
  shipToAddress$: Observable<any> = this.myAccountPermissionService.getShipToAddress();
  address: any = { shippingAddress: [], billingAddress: [] };
  hasShippingPending: boolean;
  hasBillingPending: boolean;
  isDesktop = false;
  count = 0;
  csDesktopWidth = this.breakpointService.getSize(BREAKPOINT.lg);

  showSnahAccountPermission$ = this.snahCountryService.getSnahFeatures(ACCOUNT_PERMISSIONS);
  showAccountPermission: boolean;
  snahAccountPermissionSubscription: Subscription;
  addressList: any;
  hasAddress = false;
  closeModalSubscription$: Subscription;

  activeCountry$: Observable<string> = this.countryService.getActive();

  isEditBillingAddressEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, EDIT_BILLING_ADDRESS)
    )
  );
  isRequestNewDeliveryAddressEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, REQUEST_NEW_DELIVERY_ADDRESS)
    )
  );
  isDeleteDeliveryAddressEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, DELETE_DELIVERY_ADDRESS)
    )
  );
  isCountyEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) => this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, COUNTY))
  );
  isChangeDefaultDeliveryAddressEnabled$: Observable<boolean> = this.baseSiteConfigService
    .getBaseSiteConfigValues$([CHANGE_DELIVERY_ADDRESS])
    .pipe(
      shareReplay(),
      switchMap((configs) =>
        combineLatest([
          of(
            configs &&
              configs
                .filter((config: any) => config.key === CHANGE_DELIVERY_ADDRESS)
                .map((res: any) => res.value === 'true')[0]
          ),
          this.activeCountry$,
        ])
      ),
      switchMap(([isChangeEnabled, activeCountry]) =>
        iif(
          () => isChangeEnabled,
          this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, EDIT_DEFAULT_DELIVERY_ADDRESS),
          of(false)
        )
      )
    );

  constructor(
    private personalInfoSvc: MyaccountPersonalInfoService,
    public formBuilder: FormBuilder,
    private breakpointService: BreakpointService,
    private shimanoBusinessTypeService: ShimanoBusinessTypeService,
    private shimanoCountryService: ShimanoCountryService,
    private cdr: ChangeDetectorRef,
    private countryService: ShimanoCountryService,
    private myaccountFeaturesConfigSerivce: MyaccountFeaturesConfigService,
    private baseSiteConfigService: BaseSiteConfigService,
    public deviceDetectorService: DeviceDetectorService,
    protected modalService: StandardModalService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef,
    private snahCountryService: SnahCountryService,
    private myAccountPermissionService: MyAccountPermissionService,
    private storageService: StorageService
  ) {}

  get businessType(): string {
    let businessType: string;
    this.shimanoBusinessTypeService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (businessType = data));
    return businessType;
  }

  get country(): string {
    let country: string;
    this.shimanoCountryService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (country = data));
    return country;
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > this.csDesktopWidth) {
      this.isDesktop = true;
    } else {
      this.isDesktop = false;
    }
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.isDesktop = window.innerWidth >= this.csDesktopWidth;

    this.snahAccountPermissionSubscription = this.showSnahAccountPermission$.subscribe((hasAccountPermission) => {
      this.showAccountPermission = hasAccountPermission;
      this.getAddress(this.showAccountPermission);
    });
  }

  getAddress(hasAccountPermission: boolean) {
    this.storageService.removeSessionStorageItem('country');
    this.storageService.removeSessionStorageItem('line1');
    this.storageService.removeSessionStorageItem('line2');
    this.storageService.removeSessionStorageItem('postalcode');
    this.storageService.removeSessionStorageItem('city');
    this.storageService.removeSessionStorageItem('state');
    this.storageService.removeSessionStorageItem('statename');
    this.storageService.removeSessionStorageItem('county');
    this.storageService.removeSessionStorageItem('fname');
    this.storageService.removeSessionStorageItem('lname');

    if (hasAccountPermission) {
      this.addressList = this.shipToAddress$;
    } else {
      this.addressList = this.address$;
    }

    this.addressList.subscribe((data: any) => {
      const shippingAddress = [];
      const billingAddress = [];
      for (const addresses of data.addresses) {
        // DELIVERY ADDRESS
        if (addresses.shippingAddress === true) {
          if (addresses.approvalStatus === 'PENDING') {
            this.hasShippingPending = true;
          }
          shippingAddress.push(addresses);
        }

        // BILLING ADDRESS
        if (addresses.billingAddress === true) {
          if (addresses.approvalStatus === 'PENDING' && addresses.visibleInAddressBook) {
            this.hasBillingPending = true;
          }
          if (addresses.approvalStatus === 'APPROVED' && addresses.visibleInAddressBook) {
            billingAddress.push(addresses);
          }
        }
      }
      if (shippingAddress.length > 0) {
        this.address.shippingAddress = [];
        this.address.shippingAddress = shippingAddress;
      }
      if (billingAddress.length > 0) {
        this.address.billingAddress = [];
        this.address.billingAddress = billingAddress;
      }
      this.hasAddress = true;
      this.cdr.detectChanges();
      return this.address;
    });
  }

  setDefaultAdd(address: any) {
    const payload: DefaultAddressPayload = {
      addressId: address,
    };
    this.personalInfoSvc.setDefaultAddress(payload).subscribe((data) => {
      this.getAddress(this.showAccountPermission);
    });
  }

  deleteAddressModal(addressId: any) {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.DELETE_DELIVERY_ADDRESS, this.el, this.vcr, { addressId: addressId })
      ?.pipe(take(1))
      .subscribe();

    this.closeModalSubscription$ = this.modalService.getClosedModalData().subscribe((result) => {
      if (result !== undefined) {
        this.hasShippingPending = result.isPending;
        this.getAddress(this.showAccountPermission);
        this.cdr.detectChanges();
      }
    });
  }

  onRequestNewDeliveryAddr() {
    this.storageService.removeSessionStorageItem('fieldChange');
    this.storageService.removeSessionStorageItem('user_input_values');
    sessionStorage.setItem('onbilling', 'true');

    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.REQUEST_NEW_DELIVERY_ADDRESS, this.el, this.vcr, {
        isDesktop: this.isDesktop,
        isDisabled: true,
      })
      ?.pipe(take(1))
      .subscribe();

    this.closeModalSubscription$ = this.modalService.getClosedModalData().subscribe((result) => {
      if (result !== undefined) {
        this.hasShippingPending = result.isPending;
        this.getAddress(this.showAccountPermission);
        this.cdr.detectChanges();
      }
    });
  }

  updateBIllingAddressModal(
    country: string,
    line1: string,
    line2: string,
    postalCode: string,
    city: string,
    state: string,
    statename: string,
    county: string,
    fname: string,
    lname: string
  ) {
    [
      'onbilling',
      'country',
      'line1',
      'line2',
      'postalcode',
      'city',
      'state',
      'statename',
      'county',
      'fname',
      'lname',
    ].forEach((key) => sessionStorage.removeItem(key));

    sessionStorage.setItem('onbilling', 'true');
    sessionStorage.setItem('country', country);
    sessionStorage.setItem('line1', line1);
    sessionStorage.setItem('line2', line2);
    sessionStorage.setItem('postalcode', postalCode);
    sessionStorage.setItem('city', city);
    sessionStorage.setItem('state', state);
    sessionStorage.setItem('statename', statename);
    sessionStorage.setItem('county', county);
    sessionStorage.setItem('fname', fname);
    sessionStorage.setItem('lname', lname);

    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.CHANGE_BILLING_ADDRESS, this.el, this.vcr, {
        isDesktop: this.isDesktop,
        isDisabled: true,
      })
      ?.pipe(take(1))
      .subscribe();

    this.closeModalSubscription$ = this.modalService.getClosedModalData().subscribe((result) => {
      if (result !== undefined) {
        if (result !== 'Close') {
          this.hasBillingPending = result.isPending;
        } else {
          this.storageService.removeSessionStorageItem('onbilling');
        }
        this.cdr.detectChanges();
      }
    });
  }

  showAddress(addresses: any): string {
    let address: string;
    if (addresses) {
      if (addresses.addressName) {
        if (addresses.line2) {
          address = `<span class="address-name">${addresses.addressName}: </span>${addresses?.line1} ${addresses?.line2}`;
        } else {
          address = `<span class="address-name">${addresses.addressName}: </span>${addresses?.line1}`;
        }
      } else {
        address = `${addresses?.line1} ${addresses?.line2 ? addresses?.line2 : ''}`;
      }
    }
    return address;
  }

  ngOnDestroy() {
    this.snahAccountPermissionSubscription?.unsubscribe();
    this.closeModalSubscription$?.unsubscribe();
  }
}
